import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';

function CreateLayerDivitionModal(props) {
  const { setOpen, showNotify } = props;
  const layerDivition = props.model;

  return (
    <Modal
      title={
        layerDivition.id === undefined
          ? 'Nueva agrupamiento de capas'
          : `Actualizando agrupamiento ${layerDivition.name}`
      }
      showNotify={showNotify}
      entity="base/layer-divition"
      setOpen={setOpen}
      model={layerDivition}
      reload={props.reload}
      fullWidth
      maxWidth={'xs'}
    >
      <TextField
        label="Nombre"
        defaultValue={layerDivition.name || ''}
        name="name"
        required
        fullWidth
        margin="normal"
      />
    </Modal>
  );
}

export default CreateLayerDivitionModal;
